import { gql } from '@apollo/client';

export default gql`
  mutation createPreviewData {
    createPreviewData {
      key
      expiredAt
    }
  }
`; 